const sizeClasses = {
  sm: "gap-1 px-2 py-0.5 text-[10px]",
  md: "gap-1 px-2.5 py-1 text-xs",
  lg: "gap-1.5 px-3 py-1 text-sm",
};

const iconSizeClasses = {
  sm: "text-[9px]",
  md: "text-[10px]",
  lg: "text-xs",
};

/**
 * Pill shown wherever access or a LunaKey is provided by a reseller rather
 * than owned by the customer.
 *
 * @param {{ size?: "sm"|"md"|"lg", title?: string }} props
 * @returns {import("react").ReactElement}
 */
const ResellerManagedBadge = ({
  size = "md",
  title = "Managed by a reseller. The reseller keeps full control of this access.",
}) => (
  <span
    className={`inline-flex items-center whitespace-nowrap rounded-full font-semibold bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300 ${
      sizeClasses[size] || sizeClasses.md
    }`}
    title={title}
  >
    <i
      className={`fas fa-user-shield ${iconSizeClasses[size] || iconSizeClasses.md}`}
    />
    Reseller Managed
  </span>
);

/**
 * Neutral counterpart to ResellerManagedBadge for customer-owned rows.
 *
 * @param {{ size?: "sm"|"md"|"lg" }} props
 * @returns {import("react").ReactElement}
 */
export const CustomerManagedBadge = ({ size = "md" }) => (
  <span
    className={`inline-flex items-center whitespace-nowrap rounded-full font-medium bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300 ${
      sizeClasses[size] || sizeClasses.md
    }`}
  >
    Customer Managed
  </span>
);

export default ResellerManagedBadge;
